import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  InputAdornment,
  Snackbar
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useNavigate } from 'react-router-dom';
import { greenColor, whiteColor } from '../../utils/colors';

const DemoAccessPage = () => {
  const [snack, setSnack] = useState('');
  const navigate = useNavigate();

  const dummyEmail = 'demo@findmyroommates.in';
  const dummyPassword = 'demo123';

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    setSnack(`${label} copied!`);
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2, // padding on mobile screens
      }}
    >
      <Box
        maxWidth="400px"
        width="100%"
        p={4}
        borderRadius="16px"
        boxShadow={3}
        textAlign="center"
        sx={{
          bgcolor: whiteColor
        }}
      >
        <Typography variant="h5" gutterBottom>
          Demo Access
        </Typography>

        <Typography variant="body2" color="textSecondary" mb={3}>
          Use these credentials on the login page to explore the app.<br />
          Some features may be limited.
        </Typography>

        <TextField
          fullWidth
          label="Email"
          value={dummyEmail}
          margin="normal"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => copyToClipboard(dummyEmail, 'Email')}>
                  <ContentCopyIcon />
                </IconButton>
              </InputAdornment>
            )
          }}
        />

        <TextField
          fullWidth
          label="Password"
          value={dummyPassword}
          type="password"
          margin="normal"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => copyToClipboard(dummyPassword, 'Password')}>
                  <ContentCopyIcon />
                </IconButton>
              </InputAdornment>
            )
          }}
        />

        <Button
          variant="outlined"
          fullWidth
          sx={{
            mt: 3,
            color: greenColor,
            borderColor: greenColor,
            '&:hover': {
              borderColor: 'black',
            },
          }}
          onClick={() => navigate('/fmr/sign-in')}
        >
          Go to Login Page
        </Button>

        <Typography variant="body2" mt={2}>
          Want full access?{' '}
          <Button
            variant="text"
            size="small"
            onClick={() => navigate('/fmr/sign-up')}
            sx={{ color: greenColor }} 
          >
            Sign up here
          </Button>
        </Typography>

        <Snackbar
          open={!!snack}
          autoHideDuration={2000}
          message={snack}
          onClose={() => setSnack('')}
        />
      </Box>
    </Box>
  );
};

export default DemoAccessPage;
